import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
  loadingUnits: false,
  unitsList: [],
  totalUnits: 0,
  error: null,
};

const route = "modules/manage/views/main/components/crewTab/redux/slice.";

export const manageSearchUnits = createAsyncThunk(
  "manage/crewTab/manageSearchUnits",
  async ({ conditions, sort, limit, offset }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchUnits.query,
        {
          conditions,
          sort,
          limit,
          offset,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchUnits");
      return rejectWithValue(exc);
    }
  }, 
  {
    condition: (_, { getState }) => {
      const { manageUnitsRedux } = getState();
      return !manageUnitsRedux.loadingUnits;
    },
  }
);

manageSearchUnits.query = `
    query ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
        data: searchUnits(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                label
                crews {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`;

const manageUnitsRedux = createSlice({
  name: "manage/unitCrewTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {


    builder.addCase(manageSearchUnits.pending, (state) => {
      state.loadingUnits = true;
    });
    builder.addCase(manageSearchUnits.fulfilled, (state, action) => {
      state.loadingUnits = false;
      state.unitsList = action.payload.items;
      state.totalUnits = action.payload.total;
    });
    builder.addCase(manageSearchUnits.rejected, (state, action) => {
      state.loadingUnits = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageUnitsRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
